import { type ButtonHTMLAttributes, forwardRef, type ReactNode, useRef } from 'react'

import { Button } from './Button'

type Props = {
	children?: ReactNode
	onClick?: () => void
	allowMultiClick?: boolean
	/**
	 * Optionally add an identifier to make something recognizable in testing suites
	 */
	testId?: string
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'>

const multiClickTimeout = 400

export const ButtonPlain = forwardRef<HTMLButtonElement, Props>(
	({ children, onClick, allowMultiClick = false, type = 'button', testId, ...rest }, ref) => {
		const multiClickTracker = useRef<Timeout | null>(null)

		return (
			<Button
				{...rest}
				ref={ref}
				type={type}
				data-test-id={testId}
				onClick={(event) => {
					event.stopPropagation()
					if (!onClick) {
						return
					}

					if (!allowMultiClick) {
						const hasTimer = multiClickTracker.current !== null
						if (hasTimer) {
							clearTimeout(multiClickTracker.current!)
						}
						multiClickTracker.current = setTimeout(() => {
							multiClickTracker.current = null
						}, multiClickTimeout)

						if (hasTimer) {
							return
						}
					}

					onClick()
				}}
			>
				{children}
			</Button>
		)
	},
)
